<template>
  <div class="card mt-2" style="padding: 1rem">
    <div slot="header" class="align-items-center">
      <div class="col-sm-12 col-md-12">
        <h5 class="h3 mb-0">Filtros</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-4">
          Configure quais dados deverão ser listados:
        </h6>
      </div>
    </div>
    <div class="card-body">
      <div class="col-sm-12 col-md-12">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-3">
            <anosafra-multiselect 
              v-model="filters.anosafra"
              label="Ano Safra"
              :required="true"
              :preserveSearch="true"
              placeholder="Selecionar um anosafra"
            />
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <label class="form-control-label d-block mb-3">Marca</label>
            <multiselect
              :loading="loadingBrand"
              v-model="filters.brand"
              :options="brands"
              label="name"
              track-by="id"
              :allow-empty="true"
              :preserveSearch="true"
              @search-change="debouncedRequest($event, getBrands)"
              placeholder="Selecionar uma marca"
              :selected-label="'Selecionado'">
            </multiselect>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <label class="form-control-label d-block mb-3">Grupo</label>
            <multiselect
              :loading="loadingGroup"
              v-model="filters.group"
              :options="groups"
              label="descricao"
              track-by="id"
              :allow-empty="true"
              :preserveSearch="true"
              @search-change="debouncedRequest($event, getGroups)"
              placeholder="Selecionar um grupo"
              :selected-label="'Selecionado'">
            </multiselect>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <label class="form-control-label d-block mb-3">Produto</label>
            <multiselect
              :loading="loadingPreferredproduct"
              v-model="filters.preferredproduct"
              :options="preferredproducts"
              label="name"
              track-by="id"
              :allow-empty="true"
              :preserveSearch="true"
              @search-change="debouncedRequest($event, getProducts)"
              placeholder="Selecionar um produto"
              :selected-label="'Selecionado'">
            </multiselect>
          </div>
          <div class="col-12 col-sm-12 col-md-3">
            <label class="form-control-label">Coluna</label>
            <multiselect
              :value="filters.tableColumn"
              @input="handleColumnChange"
              :options="tableColumn"
              :multiple="true"
              :close-on-select="false"
              :preserve-search="true"
              :limit="1"
              :limit-text="count => `+${count}`"
            >
              <template #tag="{ option, remove }">
                <span
                  class="multiselect__tag"
                  :class="{ 'tag-obrigatoria': ['Vol. Meta Fornec.'].includes(option) }"
                >
                  {{ option }}
                  <span
                    v-if="!['Vol. Meta Fornec.'].includes(option)"
                    @click="remove(option)"
                    class="multiselect__tag-icon"
                  ></span>
                </span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="float-right">
        <base-button type="secondary" class="mx-2"  @click="resetFilter()">Limpar</base-button>
        <el-tooltip placement="top" content="É necessário preencher filtros obrigratórios" :disabled="!disabled">
          <base-button type="secondary" class="mx-2" v-loading="loadingPdf" @click="generatePdf()" :disabled="disabled">Gerar PDF</base-button>
        </el-tooltip>
        <el-tooltip placement="top" content="É necessário preencher filtros obrigratórios" :disabled="!disabled">
          <base-button type="success" class="ml-2" :disabled="disabled" @click="search()">Pesquisar</base-button>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>

import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";
import { Table, TableColumn, Tooltip } from "element-ui";

export default {
  name: "SupplierPurchaseGoalFilters",
  components: {
    Multiselect,
    AnosafraMultiselect,
    [Tooltip.name]: Tooltip,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      active: true,
      filters: {
        anosafra: "",
        brand: "",
        group: null,
        preferredproduct: null,
        tableColumn: ['Vol. Meta Fornec.']
      },
      anosafras: [],
      brands: [],
      groups: [],
      preferredproducts: [],
      requestTimeout: null,
      loadingAnosafra: false,
      loadingBrand: false,
      loadingGroup: false,
      loadingPreferredproduct: false,
      loadingPdf: false,
      mandatoryColumns: ['Vol. Meta Fornec.'],
      tableColumn: ['Produto', 'Custo', 'Vol. Meta Fornec.', 'R$ Meta Fornec.', 'Saldo em Estoque', 'R$ Estoque',
        'Volume Meta Dist.SGV', 'R$ Meta Dist.SGV', 'Saldo Meta Forne.', 'R$ Compra', 'Meta Fornecedor x Vol Distribuído', 'Todas'
      ],
      defaultColumns: []
    }
  },
  mounted() {
    this.getBrands()
    this.getGroups()
    this.getProducts()
    this.markDefaultColumnAsSelected()
    this.filters.tableColumn.push(this.tableColumn[11])
  },
  methods: {
    async generatePdf() {
      this.loadingPdf = true;
      try {
        const serviceParams = {
          q: {
            anosafra_id: this.filters.anosafra.id,
          },
          columns: this.filters.tableColumn.filter(col => col !== 'Todas'), // Filtra colunas selecionadas
        };

        if (this.filters.brand) {
          serviceParams.q.brand_id = this.filters.brand.id;
        }
        if (this.filters.group) {
          serviceParams.q.grupo_id = this.filters.group.id;
        }
        if (this.filters.preferredproduct) {
          serviceParams.q.preferredproduct_id = this.filters.preferredproduct.id;
        }

        const response = await this.$http.secured.get("/api/v1/report/supplier_purchase_goals.pdf", {
          params: { service_params: serviceParams, selected_columns: this.filters.tableColumn.filter(col => col !== 'Todas') },
          responseType: "arraybuffer"
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", `meta_de_compra.pdf`);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingPdf = false;
      }
    },
    debouncedRequest(query, functionToCall, timeoutTime = 500){
      if(this.requestTimeout) clearTimeout(this.requestTimeout);

      this.requestTimeout = setTimeout(() => functionToCall(query), timeoutTime)
    },
    async getBrands(query = null) {
      let q = {}
      q.with_preferredproducts = true

      if (query && query.length > 0) q.name = query

      this.loadingBrand = true
      const { data } = await this.$http.secured.get(`/api/v2/brands`, { params: { q: q } })

      this.brands = data.data
      this.loadingBrand = false
    },
    async getGroups(query = null) {
      let q = {}
      if (query && query.length > 0) q.descricao = query

      this.loadingGroup = true
      const { data } = await this.$http.secured.get(`/api/v1/grupos`, { params: { q: q } })

      this.groups = data
      this.loadingGroup = false
    },
    async getProducts(query = null) {
      const q = {status: 'active'}
      if (this.filters.brand) q.brand_id = this.filters.brand.id
      if (this.filters.group) q.grupo_id = this.filters.group.id
      if (query && query.length > 0) q.name = query

      this.loadingPreferredproduct = true
      const { data } = await this.$http.secured.get(`/api/v2/preferredproducts`, { params: { q: q } })

      this.preferredproducts = data.data
      this.loadingPreferredproduct = false

    },
    search() {
      let eventFilter = {}

      // Filtra e ordena as colunas selecionadas conforme a ordem definida
      if (this.filters.tableColumn) {
        if (this.filters.tableColumn.includes('Todas')) {
          // Remove "Todas" e mantém a ordem original
          eventFilter.tableColumn = this.tableColumn.filter(col => col !== 'Todas');
        } else {
          // Filtra apenas as colunas selecionadas, na ordem do array `tableColumn`
          eventFilter.tableColumn = this.tableColumn.filter(col =>
            this.filters.tableColumn.includes(col)
          );
        }
      }

      for (const [key, value] of Object.entries(this.filters)) {
        if (value == null) continue;

        eventFilter[`${key}_id`]  = value.id
        eventFilter[key]  = value
      }

      this.$emit('search', eventFilter)
    },
    resetFilter() {
      this.filters.anosafra = "",
      this.filters.brand = null,
      this.filters.group = null,
      this.filters.preferredproduct = null,
      this.filters.tableColumn = ['Vol. Meta Fornec.'],
      this.search()
    },
    markDefaultColumnAsSelected() {
      if (!this.defaultColumns || !this.defaultColumns.length || !this.tableColumn.length) return;

      this.filters.tableColumn = this.filters.tableColumn.filter(column => this.defaultColumns.includes(column));
    },
    handleColumnChange(selected) {
      // Filtra apenas colunas válidas (removendo 'Todas' se necessário)
      const validSelected = selected.filter(col =>
        this.tableColumn.includes(col) && col !== 'Todas'
      );

      // Combina colunas obrigatórias com selecionadas, mantendo a ordem original
      const orderedColumns = this.tableColumn.filter(col =>
        this.mandatoryColumns.includes(col) || validSelected.includes(col)
      );

      this.filters.tableColumn = orderedColumns;

      // Lógica para "Todas"
      if (selected.includes('Todas') && selected.length > 1) {
        this.filters.tableColumn = [...this.mandatoryColumns, ...this.tableColumn.filter(
          col => !this.mandatoryColumns.includes(col) && col !== 'Todas'
        )];
      }
    }
  },
  watch: {
    "filters.group": function (val) {
      this.getProducts()
    },
    "filters.brand": function (val) {
      this.getProducts()
    },
    'filters.tableColumn': {
      handler(newVal) {
        if (newVal.includes('Todas') && newVal.length > 1) {
          // Se "Todas" foi selecionada junto com outras opções, manter apenas "Todas"
          this.filters.tableColumn = ['Todas'];
        }
        if(!this.disabled){
          this.search(); // Dispara pesquisa automaticamente ao mudar colunas
        }
      },
      deep: true
    }
  },
  computed: {
    disabled() {
      return this.filters.anosafra === null || this.filters.anosafra.length === 0
    }
  }
}

</script>
<style>
  .tag-obrigatoria {
    background-color: #e1f5fe !important;
    cursor: not-allowed !important;
  }
  .tag-obrigatoria .multiselect__tag-icon {
    display: none !important;
  }
</style>
